class Retype {
  constructor() {
    this.settings = {
      retypePhrases: this.getRetypePhrases(),
      index: -1,
      element: document.getElementById("retype")
    }
    this.retypeStart();
  }

  /**
   * @get retype phrases from DOM
   */
  getRetypePhrases = () => {
    let container = document.querySelector('.typing-container'),
      wordsWrap = Array.from(container.querySelectorAll('.retype-additional')),
      wordlist = [];

    wordsWrap.forEach(word => {
      wordlist.push(word.innerHTML);
    })

    return wordlist;
  }

  /**
   * @desc  func for reinit deleting letters
   */
  deleteRepeat = () => {
    this.deleteLetter();
  }

  /**
   * @desc func for deleting last letter
   */
  deleteLetter = () => {
    let newWord = this.settings.element.innerHTML;

    if(newWord.length > 0) {
      newWord = newWord.substring(0, newWord.length - 1);
      setTimeout(() => {
        this.settings.element.innerHTML = newWord;
        this.deleteRepeat();
      },75)
    } else {
      this.newLetter();
    }
  }

  /**
   * @desc func for reinit add new letter
   */
  newRepeat = () => {
    this.newLetter();
  }

  /**
   * @desc func for adding new letter
   */
  newLetter = () => {
    let newWord = this.settings.element.innerHTML;

    if(newWord.length === 0) {
      this.settings.index++;

      if(this.settings.index >= this.settings.retypePhrases.length) {
        this.settings.index = 0;
      }
    }

    let newLetters = this.settings.retypePhrases[this.settings.index];
    if(newLetters.length > newWord.length) {
      let time = Math.round(Math.random() * 100) + 100;

      newLetters = newLetters.substring(0, newWord.length + 1);

      setTimeout(() => {
        this.settings.element.innerHTML = newLetters;
        this.newLetter();
      }, time);
    } else {
      this.retypeStart();
    }
  }

  /**
   * @desc func for starting animation
   */
  retypeStart = () => {
    setTimeout(() => {
        this.deleteLetter();
    }, 1000)
  }
}

if(document.querySelector('#retype')) {
  new Retype();
}
